import React from 'react'

import { FormGroup, Checkbox, FormControlLabel, Typography, Box, Tooltip } from '@material-ui/core'

const NotificationsButton = (props) => {
	const { onActiveNotifications, user } = props

	const onChangeEnable = (activeNotifications, allowProviderNotification) => {
		onActiveNotifications(user.Token, activeNotifications, allowProviderNotification)
	}

	return (
		<div>
			<Box width='80%' display='flex' justifyConten='center'>
				<FormGroup>
					<FormControlLabel
						control={
							<Checkbox
								checked={user.ActiveNotifications}
								color='primary'
								onChange={(event) => onChangeEnable(!user.ActiveNotifications, user.AllowProviderNotification)}
							/>
						}
						label={<Typography variant='body1'>Enable Notifications</Typography>}
					/>
					<Tooltip title='This option applies to the services section'>
						<FormControlLabel
							control={
								<Checkbox
									checked={user.AllowProviderNotification}
									color='primary'
									onChange={(event) => onChangeEnable(user.ActiveNotifications, !user.AllowProviderNotification)}
								/>
							}
							label={<Typography variant='body1'>Allow Provider Notification </Typography>}
						/>
					</Tooltip>
				</FormGroup>
			</Box>
		</div>
	)
}

export default NotificationsButton
